import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import {DeviceService} from '../services/core/device.service';
import {environment} from "../../environments/environment";

@Injectable()
export class DeviceInterceptor implements HttpInterceptor {

  constructor(private deviceService: DeviceService) {
  }

  /**
   *
   * @param request
   * @param next
   */
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if(this.deviceService.info) {
      const deviceInfo = {
        operating_system: this.deviceService.info.operatingSystem,
        os_version: this.deviceService.info.osVersion,
        model: this.deviceService.info.model,
        manufacturer: this.deviceService.info.manufacturer,
        platform: this.deviceService.info.platform,
        web_view_version: this.deviceService.info.webViewVersion,
        is_virtual: this.deviceService.info.isVirtual,
        mem_used: this.deviceService.info.memUsed,
        version: environment.appVersion
      };

      return next.handle(request.clone({
        headers: request.headers.set('Device', JSON.stringify(deviceInfo))
      }));
    }
    return next.handle(request);
  }

}
